/* eslint-disable */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import _ from 'lodash';
import { connect } from 'react-redux';
import alert from 'react-s-alert';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import withCmsForm from 'modules/common/hoc/withCmsForm';
import * as actions from 'modules/settings/cms/action';
import * as c from 'modules/settings/cms/constant';

const CMS_TYPE = 'CEDULA';

const fields = [
  'CEDULA_INDIVIDUAL_SIGNATORY_NAME',
  'CEDULA_INDIVIDUAL_SIGNATORY_DESIGNATION',
  'CEDULA_INDIVIDUAL_SIGNATORY_SIGNATURE',
  'CEDULA_CORPORATION_SIGNATORY_NAME',
  'CEDULA_CORPORATION_SIGNATORY_DESIGNATION',
  'CEDULA_CORPORATION_SIGNATORY_SIGNATURE',
  'CEDULA_INDIVIDUAL_NOTE',
  'CEDULA_INDIVIDUAL_BASIC_AMOUNT',
  'CEDULA_INDIVIDUAL_BASE_INTEREST_RATE',
  'CEDULA_INDIVIDUAL_DESCRIPTION_1',
  'CEDULA_INDIVIDUAL_DESCRIPTION_2',
  'CEDULA_INDIVIDUAL_DESCRIPTION_3',
  'CEDULA_INDIVIDUAL_DESCRIPTION_SUB_1',
  'CEDULA_INDIVIDUAL_DESCRIPTION_SUB_2',
  'CEDULA_INDIVIDUAL_DESCRIPTION_SUB_3',

  'CEDULA_INDIVIDUAL_EMPLOYED_REQUIRED_1',
  'CEDULA_INDIVIDUAL_EMPLOYED_MINIMUM_AMOUNT_1',
  'CEDULA_INDIVIDUAL_EMPLOYED_TAXABLE_AMOUNT_1',
  'CEDULA_INDIVIDUAL_EMPLOYED_CEDULA_AMOUNT_1',

  'CEDULA_INDIVIDUAL_EMPLOYED_REQUIRED_2',
  'CEDULA_INDIVIDUAL_EMPLOYED_MINIMUM_AMOUNT_2',
  'CEDULA_INDIVIDUAL_EMPLOYED_TAXABLE_AMOUNT_2',
  'CEDULA_INDIVIDUAL_EMPLOYED_CEDULA_AMOUNT_2',

  'CEDULA_INDIVIDUAL_EMPLOYED_REQUIRED_3',
  'CEDULA_INDIVIDUAL_EMPLOYED_MINIMUM_AMOUNT_3',
  'CEDULA_INDIVIDUAL_EMPLOYED_TAXABLE_AMOUNT_3',
  'CEDULA_INDIVIDUAL_EMPLOYED_CEDULA_AMOUNT_3',

  'CEDULA_INDIVIDUAL_EMPLOYED_MAX_TOTAL_AMOUNT_PAID',

  'CEDULA_INDIVIDUAL_UNEMPLOYED_REQUIRED_1',
  'CEDULA_INDIVIDUAL_UNEMPLOYED_MINIMUM_AMOUNT_1',
  'CEDULA_INDIVIDUAL_UNEMPLOYED_TAXABLE_AMOUNT_1',
  'CEDULA_INDIVIDUAL_UNEMPLOYED_CEDULA_AMOUNT_1',
  'CEDULA_INDIVIDUAL_UNEMPLOYED_NOTE',
  'CEDULA_INDIVIDUAL_UNEMPLOYED_REQUIRED',

  'CEDULA_INDIVIDUAL_UNEMPLOYED_REQUIRED_2',
  'CEDULA_INDIVIDUAL_UNEMPLOYED_MINIMUM_AMOUNT_2',
  'CEDULA_INDIVIDUAL_UNEMPLOYED_TAXABLE_AMOUNT_2',
  'CEDULA_INDIVIDUAL_UNEMPLOYED_CEDULA_AMOUNT_2',

  'CEDULA_INDIVIDUAL_UNEMPLOYED_REQUIRED_3',
  'CEDULA_INDIVIDUAL_UNEMPLOYED_MINIMUM_AMOUNT_3',
  'CEDULA_INDIVIDUAL_UNEMPLOYED_TAXABLE_AMOUNT_3',
  'CEDULA_INDIVIDUAL_UNEMPLOYED_CEDULA_AMOUNT_3',

  'CEDULA_INDIVIDUAL_UNEMPLOYED_WITH_INTEREST',
  'CEDULA_INDIVIDUAL_UNEMPLOYED_MAX_TOTAL_AMOUNT_PAID',

  'CEDULA_CORPORATION_BASIC_AMOUNT',
  'CEDULA_CORPORATION_BASE_INTEREST_RATE',

  'CEDULA_CORPORATION_DESCRIPTION_1',
  'CEDULA_CORPORATION_DESCRIPTION_2',
  'CEDULA_CORPORATION_DESCRIPTION_SUB_1',
  'CEDULA_CORPORATION_DESCRIPTION_SUB_2',

  'CEDULA_CORPORATION_REQUIRED_1',
  'CEDULA_CORPORATION_MINIMUM_AMOUNT_1',
  'CEDULA_CORPORATION_TAXABLE_AMOUNT_1',
  'CEDULA_CORPORATION_CEDULA_AMOUNT_1',

  'CEDULA_CORPORATION_REQUIRED_2',
  'CEDULA_CORPORATION_MINIMUM_AMOUNT_2',
  'CEDULA_CORPORATION_TAXABLE_AMOUNT_2',
  'CEDULA_CORPORATION_CEDULA_AMOUNT_2',

  'CEDULA_CORPORATION_MAX_TOTAL_AMOUNT_PAID',
  'CEDULA_CORPORATION_NOTE',

  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
];

const monthFields = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
];

const amountFields = fields.filter(
  (key) =>
    key.includes('BASIC_AMOUNT') ||
    key.includes('TAXABLE_AMOUNT') ||
    key.includes('CEDULA_AMOUNT') ||
    key.includes('MAX_TOTAL_AMOUNT')
);

const capitalizeLabel = (label) =>
  label.charAt(0).toUpperCase() + label.slice(1);

/** Mount FilePond only after user opts in — avoids heavy init on tab open. */
function DeferredSignatureUpload({
  formData,
  createUploader,
  fieldKey,
  label,
}) {
  const [showUploader, setShowUploader] = useState(false);
  const value = _.get(formData, fieldKey);
  const hasValue = !!value;

  if (showUploader) {
    return createUploader(
      {
        key: fieldKey,
        label,
        sub: '(.png type ONLY, Max: 5MB)',
      },
      {
        acceptedFileTypes: ['image/png'],
        placeholder: label,
      }
    );
  }

  return (
    <div className="w-100 text-center">
      <label className="form-label d-flex align-items-center m-0 mr-1">
        <span>{label}</span>
      </label>
      <small className="d-block mb-2 font-weight-bold text-danger">
        (.png type ONLY, Max: 5MB)
      </small>
      <img
        className="w-100 rounded mb-2"
        src={value || ImagePlaceholder}
        alt={label}
        style={{ maxHeight: 180, objectFit: 'contain' }}
      />
      <button
        type="button"
        className="btn btn-sm btn-outline-primary"
        onClick={() => setShowUploader(true)}
      >
        {hasValue ? 'Change signature' : 'Upload signature'}
      </button>
    </div>
  );
}

DeferredSignatureUpload.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  createUploader: PropTypes.instanceOf(Function).isRequired,
  fieldKey: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

function InterestTab({ createInput }) {
  return (
    <div className="row m-3">
      <div className="col-12 form-group group-cms-color">
        <h3 className="form-label font-weight-bold">Interest Table</h3>
      </div>
      {monthFields.map((month) => (
        <div key={month} className="col-6 group-cms-color form-input-group pb-3">
          {createInput(
            {
              key: month,
              label: capitalizeLabel(month),
            },
            { type: 'text' }
          )}
        </div>
      ))}
    </div>
  );
}

InterestTab.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
};

/**
 * Fee block layout from design mockup:
 * Title
 * [Description] [Subtitle]
 * [Required?] [Taxable Amount] [Cedula Amount] [Minimum Amount]
 */
function FeeSetupBlock({
  title,
  createInput,
  createCheckbox,
  createTextArea,
  descriptionKey,
  subtitleKey,
  requiredKey,
  taxableKey,
  cedulaKey,
  minimumKey,
  descriptionDisabled,
}) {
  return (
    <React.Fragment>
      <div className="col-12 form-group group-cms-color pt-4">
        <h3 className="form-label font-weight-bold">{title}</h3>
      </div>
      <div className="col-6 group-cms-color form-input-group pb-3">
        {createTextArea(
          { key: descriptionKey, label: 'Description' },
          { disabled: !!descriptionDisabled }
        )}
      </div>
      <div className="col-6 group-cms-color form-input-group pb-3">
        {createTextArea({ key: subtitleKey, label: 'Subtitle' })}
      </div>
      <div className="col-3 group-cms-color form-input-group d-flex pb-3">
        {createCheckbox(
          { key: requiredKey, label: 'Required?' },
          { className: 'd-flex align-items-center align-self-center' }
        )}
      </div>
      <div className="col-3 group-cms-color form-input-group pb-3">
        {createInput(
          { key: taxableKey, label: 'Taxable Amount' },
          { type: 'number' }
        )}
      </div>
      <div className="col-3 group-cms-color form-input-group pb-3">
        {createInput(
          { key: cedulaKey, label: 'Cedula Amount' },
          { type: 'number' }
        )}
      </div>
      <div className="col-3 group-cms-color form-input-group pb-3">
        {createInput(
          { key: minimumKey, label: 'Minimum Amount' },
          { type: 'number' }
        )}
      </div>
    </React.Fragment>
  );
}

FeeSetupBlock.propTypes = {
  title: PropTypes.string.isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  createCheckbox: PropTypes.instanceOf(Function).isRequired,
  createTextArea: PropTypes.instanceOf(Function).isRequired,
  descriptionKey: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string.isRequired,
  requiredKey: PropTypes.string.isRequired,
  taxableKey: PropTypes.string.isRequired,
  cedulaKey: PropTypes.string.isRequired,
  minimumKey: PropTypes.string.isRequired,
  descriptionDisabled: PropTypes.bool,
};

FeeSetupBlock.defaultProps = {
  descriptionDisabled: true,
};

function SignatureSection({
  title,
  createInput,
  createUploader,
  formData,
  nameKey,
  designationKey,
  signatureKey,
}) {
  return (
    <React.Fragment>
      <div className="col-12 form-group group-cms-color pt-5">
        <h3 className="form-label font-weight-bold">{title}</h3>
      </div>
      <div className="col-12 group-cms-color form-input-group pb-3">
        {createInput({ key: nameKey, label: 'Name' })}
      </div>
      <div
        className="col-12 group-cms-color form-input-group pb-3"
        style={{ width: '20%' }}
      >
        {createInput({ key: designationKey, label: 'Designation' })}
      </div>
      <div
        className="col-6 form-group d-flex flex-column justify-content-center align-items-center border p-1 rounded"
        style={{
          marginLeft: '15px',
          marginTop: '10px',
          maxWidth: '400px',
        }}
      >
        <DeferredSignatureUpload
          formData={formData}
          createUploader={createUploader}
          fieldKey={signatureKey}
          label="Signature"
        />
      </div>
    </React.Fragment>
  );
}

SignatureSection.propTypes = {
  title: PropTypes.string.isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  createUploader: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  nameKey: PropTypes.string.isRequired,
  designationKey: PropTypes.string.isRequired,
  signatureKey: PropTypes.string.isRequired,
};

function IndividualTab({
  createInput,
  createCheckbox,
  createUploader,
  formData,
  createTextArea,
}) {
  return (
    <div className="row m-3">
      {/* Individual Employed — Note / Basic Amount / Maximum Amount */}
      <div className="col-12 form-group group-cms-color">
        <h3 className="form-label font-weight-bold">Individual Employed</h3>
      </div>
      <div className="col-4 group-cms-color form-input-group pb-3">
        {createInput(
          { key: 'CEDULA_INDIVIDUAL_NOTE', label: 'Note' },
          { type: 'text' }
        )}
      </div>
      <div className="col-4 group-cms-color form-input-group pb-3">
        {createInput(
          {
            key: 'CEDULA_INDIVIDUAL_BASIC_AMOUNT',
            label: 'Basic Amount',
          },
          { type: 'number' }
        )}
      </div>
      <div className="col-4 group-cms-color form-input-group pb-3">
        {createInput(
          {
            key: 'CEDULA_INDIVIDUAL_EMPLOYED_MAX_TOTAL_AMOUNT_PAID',
            label: 'Maximum Amount',
          },
          { type: 'number' }
        )}
      </div>

      <FeeSetupBlock
        title="Business"
        createInput={createInput}
        createCheckbox={createCheckbox}
        createTextArea={createTextArea}
        descriptionKey="CEDULA_INDIVIDUAL_DESCRIPTION_1"
        subtitleKey="CEDULA_INDIVIDUAL_DESCRIPTION_SUB_1"
        requiredKey="CEDULA_INDIVIDUAL_EMPLOYED_REQUIRED_1"
        taxableKey="CEDULA_INDIVIDUAL_EMPLOYED_TAXABLE_AMOUNT_1"
        cedulaKey="CEDULA_INDIVIDUAL_EMPLOYED_CEDULA_AMOUNT_1"
        minimumKey="CEDULA_INDIVIDUAL_EMPLOYED_MINIMUM_AMOUNT_1"
      />

      <FeeSetupBlock
        title="Salary/Profession"
        createInput={createInput}
        createCheckbox={createCheckbox}
        createTextArea={createTextArea}
        descriptionKey="CEDULA_INDIVIDUAL_DESCRIPTION_2"
        subtitleKey="CEDULA_INDIVIDUAL_DESCRIPTION_SUB_2"
        requiredKey="CEDULA_INDIVIDUAL_EMPLOYED_REQUIRED_2"
        taxableKey="CEDULA_INDIVIDUAL_EMPLOYED_TAXABLE_AMOUNT_2"
        cedulaKey="CEDULA_INDIVIDUAL_EMPLOYED_CEDULA_AMOUNT_2"
        minimumKey="CEDULA_INDIVIDUAL_EMPLOYED_MINIMUM_AMOUNT_2"
      />

      <FeeSetupBlock
        title="Real Property"
        createInput={createInput}
        createCheckbox={createCheckbox}
        createTextArea={createTextArea}
        descriptionKey="CEDULA_INDIVIDUAL_DESCRIPTION_3"
        subtitleKey="CEDULA_INDIVIDUAL_DESCRIPTION_SUB_3"
        requiredKey="CEDULA_INDIVIDUAL_EMPLOYED_REQUIRED_3"
        taxableKey="CEDULA_INDIVIDUAL_EMPLOYED_TAXABLE_AMOUNT_3"
        cedulaKey="CEDULA_INDIVIDUAL_EMPLOYED_CEDULA_AMOUNT_3"
        minimumKey="CEDULA_INDIVIDUAL_EMPLOYED_MINIMUM_AMOUNT_3"
      />

      {/* Individual Unemployed — Note / Basic Amount / With Interest */}
      <div className="col-12 form-group group-cms-color pt-5">
        <h3 className="form-label font-weight-bold">Individual Unemployed</h3>
      </div>
      <div className="col-4 group-cms-color form-input-group pb-3">
        {createInput(
          {
            key: 'CEDULA_INDIVIDUAL_UNEMPLOYED_NOTE',
            label: 'Note',
          },
          { type: 'text' }
        )}
      </div>
      <div className="col-4 group-cms-color form-input-group pb-3">
        {createInput(
          {
            key: 'CEDULA_INDIVIDUAL_UNEMPLOYED_CEDULA_AMOUNT_1',
            label: 'Basic Amount',
          },
          { type: 'number' }
        )}
      </div>
      <div className="col-4 group-cms-color form-input-group d-flex pb-3">
        {createCheckbox(
          {
            key: 'CEDULA_INDIVIDUAL_UNEMPLOYED_WITH_INTEREST',
            label: 'With Interest',
          },
          { className: 'd-flex align-items-center align-self-center' }
        )}
      </div>

      <SignatureSection
        title="Individual Signature"
        createInput={createInput}
        createUploader={createUploader}
        formData={formData}
        nameKey="CEDULA_INDIVIDUAL_SIGNATORY_NAME"
        designationKey="CEDULA_INDIVIDUAL_SIGNATORY_DESIGNATION"
        signatureKey="CEDULA_INDIVIDUAL_SIGNATORY_SIGNATURE"
      />
    </div>
  );
}

IndividualTab.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  createCheckbox: PropTypes.instanceOf(Function).isRequired,
  createUploader: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  createTextArea: PropTypes.instanceOf(Function).isRequired,
};

function CorporationTab({
  createInput,
  createCheckbox,
  createUploader,
  formData,
  createTextArea,
}) {
  return (
    <div className="row m-3">
      {/* Corporation — Note / Basic Amount / Maximum Amount */}
      <div className="col-12 form-group group-cms-color">
        <h3 className="form-label font-weight-bold">Corporation</h3>
      </div>
      <div className="col-4 group-cms-color form-input-group pb-3">
        {createInput(
          { key: 'CEDULA_CORPORATION_NOTE', label: 'Note' },
          { type: 'text' }
        )}
      </div>
      <div className="col-4 group-cms-color form-input-group pb-3">
        {createInput(
          {
            key: 'CEDULA_CORPORATION_BASIC_AMOUNT',
            label: 'Basic Amount',
          },
          { type: 'number' }
        )}
      </div>
      <div className="col-4 group-cms-color form-input-group pb-3">
        {createInput(
          {
            key: 'CEDULA_CORPORATION_MAX_TOTAL_AMOUNT_PAID',
            label: 'Maximum Amount',
          },
          { type: 'number' }
        )}
      </div>

      <FeeSetupBlock
        title="Real Property"
        createInput={createInput}
        createCheckbox={createCheckbox}
        createTextArea={createTextArea}
        descriptionKey="CEDULA_CORPORATION_DESCRIPTION_1"
        subtitleKey="CEDULA_CORPORATION_DESCRIPTION_SUB_1"
        requiredKey="CEDULA_CORPORATION_REQUIRED_1"
        taxableKey="CEDULA_CORPORATION_TAXABLE_AMOUNT_1"
        cedulaKey="CEDULA_CORPORATION_CEDULA_AMOUNT_1"
        minimumKey="CEDULA_CORPORATION_MINIMUM_AMOUNT_1"
      />

      <FeeSetupBlock
        title="Business"
        createInput={createInput}
        createCheckbox={createCheckbox}
        createTextArea={createTextArea}
        descriptionKey="CEDULA_CORPORATION_DESCRIPTION_2"
        subtitleKey="CEDULA_CORPORATION_DESCRIPTION_SUB_2"
        requiredKey="CEDULA_CORPORATION_REQUIRED_2"
        taxableKey="CEDULA_CORPORATION_TAXABLE_AMOUNT_2"
        cedulaKey="CEDULA_CORPORATION_CEDULA_AMOUNT_2"
        minimumKey="CEDULA_CORPORATION_MINIMUM_AMOUNT_2"
      />

      <SignatureSection
        title="Corporation Signature"
        createInput={createInput}
        createUploader={createUploader}
        formData={formData}
        nameKey="CEDULA_CORPORATION_SIGNATORY_NAME"
        designationKey="CEDULA_CORPORATION_SIGNATORY_DESIGNATION"
        signatureKey="CEDULA_CORPORATION_SIGNATORY_SIGNATURE"
      />
    </div>
  );
}

CorporationTab.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  createCheckbox: PropTypes.instanceOf(Function).isRequired,
  createUploader: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  createTextArea: PropTypes.instanceOf(Function).isRequired,
};

function Components({
  updateCedulaInterest,
  getCedulaInterest,
  getList,
  item,
  resetFormData,
  createHidden,
  create,
  update,
  formData,
  createCheckbox,
  createInput,
  createUploader,
  cedulaInterest,
  isLoading,
  createTextArea,
}) {
  const [selectedTab, setSelectedTab] = useState(0);
  const [hasSynced, setHasSynced] = useState(false);

  const itemId = _.get(item, 'id');
  const interestId = _.get(cedulaInterest, 'id');
  const settingsBody = _.get(item, 'attributes.body') || '{}';
  const interestAttributes = useMemo(
    () => _.get(cedulaInterest, 'attributes') || {},
    [cedulaInterest]
  );

  // Always refetch settings (GET_SETTINGS key is shared across CMS screens).
  // Skip interest refetch when already cached.
  useEffect(() => {
    getList({ type: CMS_TYPE });
    if (_.isEmpty(interestAttributes)) {
      getCedulaInterest({});
    }
  }, []);

  // Sync server → form once per loaded payload (stable deps, no deep equal loop).
  useEffect(() => {
    if (!itemId && _.isEmpty(interestAttributes)) {
      return;
    }

    let parsedBody = {};
    try {
      parsedBody = JSON.parse(settingsBody || '{}');
    } catch (err) {
      parsedBody = {};
    }

    resetFormData({
      ...parsedBody,
      id: itemId,
      ...interestAttributes,
    });
    setHasSynced(true);
  }, [itemId, interestId, settingsBody]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const hasNegativeAmount = amountFields.some((key) => {
      const value = _.get(formData, key);
      if (value === '' || value === null || typeof value === 'undefined') {
        return false;
      }
      return Number(value) < 0;
    });

    if (hasNegativeAmount) {
      alert.error('Amount fields cannot be negative.');
      return;
    }

    const interestPayload = _.pick(formData, [...monthFields]);

    if (_.get(formData, 'id')) {
      return updateCedulaInterest(interestPayload, () => {
        update(_.get(formData, 'id'), {
          body: JSON.stringify(_.pick(formData, [...fields])),
        });
      });
    }

    return updateCedulaInterest(interestPayload, () => {
      create({
        body: JSON.stringify(_.pick(formData, [...fields])),
      });
    });
  };

  const showLoading = isLoading && !hasSynced;

  return (
    <div>
      <form onSubmit={handleOnSubmit}>
        {createHidden({ key: 'id' }, { placeholder: '' })}
        <div className="m-3">
          {showLoading ? (
            <div className="d-flex justify-content-center align-items-center py-5">
              <i className="fa fa-spin fa-spinner fa-2x" />
            </div>
          ) : (
            <Tabs
              selectedIndex={selectedTab}
              onSelect={setSelectedTab}
              forceRenderTabPanel={false}
            >
              <TabList>
                <Tab>General</Tab>
                <Tab>Individual</Tab>
                <Tab>Corporation</Tab>
              </TabList>

              <TabPanel>
                {selectedTab === 0 && (
                  <InterestTab createInput={createInput} />
                )}
              </TabPanel>

              <TabPanel>
                {selectedTab === 1 && (
                  <IndividualTab
                    createInput={createInput}
                    createCheckbox={createCheckbox}
                    createUploader={createUploader}
                    formData={formData}
                    createTextArea={createTextArea}
                  />
                )}
              </TabPanel>

              <TabPanel>
                {selectedTab === 2 && (
                  <CorporationTab
                    createInput={createInput}
                    createCheckbox={createCheckbox}
                    createUploader={createUploader}
                    formData={formData}
                    createTextArea={createTextArea}
                  />
                )}
              </TabPanel>
            </Tabs>
          )}
        </div>
        {!showLoading && (
          <div className="d-flex justify-content-center">
            <button
              type="submit"
              className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
            >
              <span className="font-weight-bold">Submit</span>
            </button>
          </div>
        )}
      </form>
    </div>
  );
}

Components.propTypes = {
  updateCedulaInterest: PropTypes.instanceOf(Function).isRequired,
  getCedulaInterest: PropTypes.instanceOf(Function).isRequired,
  getList: PropTypes.instanceOf(Function).isRequired,
  createHidden: PropTypes.instanceOf(Function).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  resetFormData: PropTypes.instanceOf(Function).isRequired,
  create: PropTypes.instanceOf(Function).isRequired,
  update: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  createCheckbox: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  createUploader: PropTypes.instanceOf(Function).isRequired,
  createTextArea: PropTypes.instanceOf(Function).isRequired,
  cedulaInterest: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  item: (_.get(api, `${c.GET_SETTINGS}.list`) || [])[0] || {},
  cedulaInterest: _.get(api, `${c.GET_CEDULA_INTEREST}.item`) || {},
  isLoading:
    (api.loading || []).indexOf(c.GET_SETTINGS) > -1 ||
    (api.loading || []).indexOf(c.GET_CEDULA_INTEREST) > -1,
});

const enhance = _.flowRight([
  withCmsForm,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(Components);
